import React from "react";
import ReactDOM from "react-dom";
import cx from "classnames";
import ArticleList from "@Components/article/articleList";
import { ArticleType, ColumnsType, NewsType } from "@Types/articles";
import { path, article } from "@Api";
import {
  fetchArticleNav,
  fetchNewsBanners,
  fetchRecommendColums,
  articleCategories,
  fetchRecommendArticleChoice,
} from "../../services/article_v2";
import { Carousel } from "antd";
import ga from "@Lib/ga";
import Movie from "../ad/movie";
import { host } from "@Services/url";

import styles from "./newsIndex.module.less";
import "@Styles/global.less";
import HotArticle from "@Components/article/categoryArticle/HotArticle";

type NavType = {
  name: string;
  contentType1: undefined | string;
  contentType2: undefined | string;
};

const { imageUrl } = path;
// const { fetchArticleNav, fetchNewsBanners, fetchRecommendColums, articleCategories, fetchRecommendArticleChoice } =
//   article;

interface IState {
  navList: NavType[];
  hotData: ArticleType[];
  bannersData: NewsType[];
  categoryData: any[];
  currentSlide: number;
  initArticleParams: any;
}

class News extends React.PureComponent<{}, IState> {
  readonly state: IState = {
    navList: [],
    hotData: [],
    bannersData: [],
    categoryData: [],
    currentSlide: 0,
    initArticleParams: { limit: 9, type: "1" },
  };

  private carouselRef = React.createRef<Carousel>();

  private fixedNavRef = React.createRef<HTMLDivElement>();

  private fetchNav = async () => {
    const res = await fetchArticleNav();

    if (res && res.status === 12000) {
      const navs = res.data.nav?.filter((item) => item.name === "新聞");

      if (navs && Array.isArray(navs)) {
        const newsNav = navs[0]?.child ?? [];

        this.setState({
          navList: [
            {
              name: "全部",
              contentType1: "新聞",
              contentType2: "",
            },
          ].concat(
            newsNav
              .filter((item) => item.name !== "售後")
              .map((item) => ({
                name: item.name,
                contentType1: "新聞",
                contentType2: item.name,
                id: item.id,
                isNative: true,
                hrefPrefix: "/news",
              })),
          ),
        });
      }
    }
  };

  private fetchBanner = async () => {
    const bannerRes = await fetchNewsBanners({
      bannerLimit: 3,
      hotLimit: 5,
    });

    if (bannerRes && bannerRes.status === 12000) {
      this.setState({
        hotData: bannerRes.data.hot,
        bannersData: bannerRes.data.focus,
      });
    }
  };

  private fetchArticleCategories = async () => {
    const categoryRes = await articleCategories({
      limit: 1,
      appendArticleLimit: 4,
    });

    if (categoryRes && categoryRes.status === 12000) {
      this.setState({
        categoryData: categoryRes.data.list,
      });
    }
  };

  private handleMouseEnter(inx: number) {
    const { current } = this.carouselRef;
    if (!current) {
      return;
    }
    current.goTo(inx);
    this.setState({ currentSlide: inx });
  }

  private paging = (dir: number) => {
    const { current } = this.carouselRef;
    if (!current) {
      return;
    }
    if (dir === 1) {
      try {
        current.next();
      } catch (e) {}
    } else if (dir === -1) {
      try {
        current.prev();
      } catch (e) {}
    }
  };

  componentDidMount() {
    this.fetchNav();
    this.fetchBanner();
    this.fetchArticleCategories();
  }

  render() {
    const { navList, bannersData, hotData, currentSlide, categoryData, initArticleParams } = this.state;

    return (
      <div className={styles["news"]}>
        <div className={styles["news-top"]}>
          <div className={styles["wrapper"]}>
            <div className={styles["top"]}>
              <img className={styles["news-img"]} src={`${imageUrl}/article/news/icon1.svg`} alt='' />
              <p></p>
            </div>
            <div className={styles["top-news"]}>
              <div className={styles["left"]}>
                <div className={styles["carousel-wrapper"]}>
                  {/* <div className={styles['prev']} onClick={() => this.paging(-1)}></div> */}
                  <Carousel className={styles["carousel"]} ref={this.carouselRef} dots={false}>
                    {bannersData.map((item, i) => (
                      <a
                        href={item.link}
                        target='_blank'
                        key={i}
                        onClick={() => ga(["新聞首頁", "文章", "頂部輪播圖"])}
                        className={cx(styles["slide-item"])}
                      >
                        <img src={item.thumb} alt='' />
                        <p>{item.title}</p>
                      </a>
                    ))}
                  </Carousel>
                  {/* <div className={styles['next']} onClick={() => this.paging(1)}></div> */}
                </div>
                <div className={styles["carousel-extra"]}>
                  {bannersData.map((item, i) => (
                    <a
                      href={item.link}
                      target='_blank'
                      key={i}
                      onClick={() => ga(["新聞首頁", "文章", "文章"])}
                      className={cx(styles["carousel-extra-item"], {
                        [styles["active"]]: currentSlide === i,
                      })}
                      onMouseEnter={() => this.handleMouseEnter(i)}
                    >
                      <p className={styles["title"]}>
                        <span>#</span>
                        {item.title}
                      </p>
                      <div className={styles["action-bar"]}>
                        <div className={styles["extra-actions"]}>
                          <div className={styles["extra-item"]}>
                            <span className={styles["extra-visit-icon"]} />
                            <span>{item.views}</span>
                          </div>
                          <div className={styles["extra-item"]}>
                            <span className={styles["extra-link-icon"]} />
                            <span>{item.likes}</span>
                          </div>
                        </div>
                        {item.tags && item.tags.length > 0 && <div className={styles["tag"]}>{item.tags[0]}</div>}
                      </div>
                    </a>
                  ))}
                </div>
              </div>
              <div className={styles["right"]}>
                <div className={styles["hot"]}>
                  <img className={styles["news-img"]} src={`${imageUrl}/article/news/icon3.png`} alt='' />
                  <ul className={styles["hot-list"]}>
                    {hotData &&
                      hotData.map((item, inx) => (
                        <li className={styles["hot-item"]}>
                          <a target='_blank' href={item.link}>
                            {item.title}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles["news-container"]}>
          <div className={styles["article-left"]}>
            <div className={styles["left-top"]}></div>
            <ArticleList nav={navList} fetchParams={initArticleParams} />
          </div>
          <div className={styles["article-right"]}>
            <div
              gad='div-gpt-ad-1508319522490-110'
              gad-tag='/173427088/newcar_pc_news_list'
              className='dfp-fluid dfp-h5'
              style={{
                height: "560px",
                width: "280px",
                marginBottom: "20px",
                display: "none",
              }}
            ></div>
            <iframe
              src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F8891newcar%2F&width=280&height=160&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId'
              width='280'
              height='160'
              style={{ border: "none", overflow: "hidden" }}
              scrolling='no'
              frameBorder='0'
              allowFullScreen={true}
              allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
            ></iframe>

            <HotArticle
              title='精選推薦'
              fetchData={fetchRecommendArticleChoice}
              fetchParams={{ limit: 10, position: "newsHome" }}
              style={{ padding: "0 0 40px 0" }}
            />

            <div className={styles["category"]}>
              <div className={styles["category-box"]}>
                <h3>
                  <p>
                    <i>HOT</i>精華合輯
                  </p>
                  <a href={`${host.c}/feature`}>更多</a>
                </h3>
                {categoryData &&
                  categoryData.map((item, inx) => (
                    <div className={styles["category-content"]} key={inx}>
                      <a className={styles["category-tile"]} href={`/feature/${item.id}`} target='_blank'>
                        <img className={styles["category-img"]} src={item.thumb} alt='' />
                        <p>#{item.title}</p>
                      </a>
                      <ul className={styles["category-list"]}>
                        {item.articles &&
                          item.articles.map((ii, i) => (
                            <a
                              target='_blank'
                              href={`${ii.link}?ca_id=${item.id}`}
                              className={styles["category-item"]}
                              key={i}
                            >
                              {ii.title}
                            </a>
                          ))}
                      </ul>
                    </div>
                  ))}
              </div>
            </div>
            {/* <a className={styles['news-line']} target="_blank" href="/compaigns/line-guide">
              <img src={`${imageUrl}/article/news/png5.png`} alt="" />
            </a> */}
            <Movie title='新聞首頁' />
          </div>
        </div>
      </div>
    );
  }
}

export default News;
